import {
	Breadcrumbs,
	useGetBackUrlFromLocation,
} from "@sembark-travel/ui-router"
import { generatePath, useNavigate } from "../../../router-utils"
import { Helmet } from "react-helmet-async"
import { ForbidUnlessAuthorized, PERMISSIONS } from "../../../Auth"
import { Box, Container } from "@sembark-travel/ui-base"
import { NewDocumentTypeItem } from "../../../DocTypes"

export default function NewDocumentTypePage() {
	const navigate = useNavigate()
	const backFromUrl = useGetBackUrlFromLocation()
	return (
		<>
			<Helmet>
				<title>New Document Types</title>
			</Helmet>
			<ForbidUnlessAuthorized permission={PERMISSIONS.MANAGE_TRIP_OWNERS}>
				<Breadcrumbs
					title="New Document Type"
					items={[
						[generatePath("/org/document/types"), "Document Types"],
						["", "New"],
					]}
				/>
				<Box paddingX={{ md: "4" }} paddingY={{ md: "8" }}>
					<Box maxWidth="4xl" marginX="auto">
						<Box borderWidth={{ md: "1" }} rounded="md" bgColor="default">
							<Container paddingY="6">
								<NewDocumentTypeItem
									onSuccess={(doc) =>
										navigate("/org/document/types", {
											replace: true,
										})
									}
									onCancel={() =>
										backFromUrl
											? navigate(backFromUrl as "/org/document/types", {
													replace: true,
												})
											: navigate("/org/document/types", { replace: true })
									}
								/>
							</Container>
						</Box>
					</Box>
				</Box>
			</ForbidUnlessAuthorized>
		</>
	)
}
